export default __webpack_public_path__ + "static/goethe-ed032faf11a8124963b7f378937bdc3e.png";